import React from "react";
import { Link } from "react-router-dom";
import { FaLinkedin } from "react-icons/fa";
import { domains } from "./Navbar";

const columns = [
  {
    title: "Solutions",
    links: [
      { name: "Semiconductor Engineering", to: "/services" },
      { name: "Startup Workforce", to: "/startup-workforce" },
      { name: "Engagement models", to: "/#how-we-engage" },
    ],
  },
  {
    title: "Capabilities",
    links: domains.map((d) => ({ name: d.name, to: `/services#${d.id}` })),
  },
  {
    title: "Company",
    links: [
      { name: "About Chiparama", to: "/company" },
      { name: "Mission & values", to: "/about" },
      { name: "Insights", to: "/news-blogs" },
      { name: "Careers", to: "/candidates" },
      { name: "Contact", to: "/contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="on-dark noise relative overflow-hidden bg-navy-950 text-slate-300">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-light/60 to-transparent" aria-hidden="true" />
      <div className="glow-blue absolute -bottom-72 left-1/2 h-[40rem] w-[60rem] -translate-x-1/2 opacity-25" aria-hidden="true" />
      <div className="container-x relative py-20 md:py-24">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div>
            <Link to="/" className="inline-flex items-center gap-2.5" aria-label="Chiparama home">
              <img src="/chiparamalogo.webp" alt="" className="h-9 w-9 rounded-lg bg-white object-contain p-0.5" width="36" height="36" />
              <span className="font-display text-lg font-semibold tracking-tight text-white">Chiparama</span>
            </Link>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
              Senior-led semiconductor engineering execution, with a US program interface and India
              engineering depth.
            </p>
            <address className="mt-6 space-y-1.5 text-sm not-italic text-slate-400">
              <p>10605 Jonwood Way, Austin, TX 78753, USA</p>
              <p>
                <a href="mailto:contact@chiparama.com" className="hover:text-white">contact@chiparama.com</a>
              </p>
              <p>
                <a href="tel:+14085948864" className="hover:text-white">+1 (408) 594-8864</a>
              </p>
            </address>
            <a
              href="https://www.linkedin.com/company/chiparama/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chiparama on LinkedIn"
              className="mt-6 inline-flex h-10 w-10 items-center justify-center rounded-lg border border-white/15 text-lg text-slate-300 transition hover:border-white/40 hover:text-white"
            >
              <FaLinkedin />
            </a>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="font-mono text-xs font-medium uppercase tracking-[0.18em] text-slate-500">{col.title}</h3>
              <ul className="mt-5 space-y-3 text-sm">
                {col.links.map((l) => (
                  <li key={l.name}>
                    <Link to={l.to} className="text-slate-300 transition-colors hover:text-white">
                      {l.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="pointer-events-none mt-16 select-none text-center font-display text-[18vw] font-semibold leading-none tracking-[-0.05em] text-transparent [-webkit-text-stroke:1px_rgba(127,160,255,0.18)] md:text-[13rem]" aria-hidden="true">
          CHIPARAMA
        </p>

        <div className="mt-6 flex flex-col gap-4 border-t border-white/10 pt-8 text-sm text-slate-500 md:flex-row md:items-center md:justify-between">
          <p>&copy; {new Date().getFullYear()} Chiparama Inc. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms-and-conditions" className="hover:text-white">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
